import { call, put, takeLatest, select, delay } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { PAYTM_MINIAPP_INITIATE_TRANSACTION, PAYTM_MINIAPP_STATUS_CHECK, PHONEPE_SWITCH_INITIATE_TRANSACTION, MINI_APP_CONSTANTS, PHONEPE_SWITCH_STATUS_CHECK, } from '../constants';
import { checkPaytmMiniAppPaymentStatus, checkPhonepeSwitchPaymentStatus, initiatePaytmMiniAppTransactionFailure, initiatePaytmMiniAppTransactionSuccess, initiatePhonepeSwitchTransactionFailure, initiatePhonepeSwitchTransactionSuccess, paytmMiniAppPaymentStatusFailure, paytmMiniAppPaymentStatusSuccess, phonepeSwitchPaymentStatusFailure, phonepeSwitchPaymentStatusSuccess, } from '../redux/Actions/MicroAppPaymentActions';
export function* paytmMiniAppPayment(request) {
    try {
        const { payload } = request;
        const { tenantId, data, customerId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paymentForPaytmMiniApp, null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.resultMsg) {
            yield put(initiatePaytmMiniAppTransactionSuccess(response));
        }
        else {
            yield put(initiatePaytmMiniAppTransactionFailure());
        }
    }
    catch (error) {
        yield put(initiatePaytmMiniAppTransactionFailure());
    }
}
export function* payforPaytmMiniApp() {
    yield takeLatest(PAYTM_MINIAPP_INITIATE_TRANSACTION, paytmMiniAppPayment);
}
export const paytmMicroAppPaymentSelector = (state) => state.microAppPaymentReducer.paytmMaxRepeatCallsCount;
export function* fetchPaytmMiniappStatus(request) {
    try {
        const { payload } = request;
        const { tenantId, transactionId, customerId, maxCallCount } = payload;
        const maxRepeatCallsCount = yield select(paytmMicroAppPaymentSelector);
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paytmMiniAppStatus, { queryProps: { transactionId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.status && maxRepeatCallsCount < maxCallCount) {
            if (response?.status === MINI_APP_CONSTANTS.SUCCESS || response?.status === MINI_APP_CONSTANTS.FAILURE) {
                yield put(paytmMiniAppPaymentStatusSuccess(response));
            }
            else {
                yield delay(MINI_APP_CONSTANTS.STATUS_DELAY_TIME);
                yield put(checkPaytmMiniAppPaymentStatus(request?.payload, maxRepeatCallsCount + 1));
            }
        }
        else {
            yield put(paytmMiniAppPaymentStatusFailure(response));
        }
    }
    catch (error) {
        yield put(paytmMiniAppPaymentStatusFailure());
    }
}
export function* checkPaytmMiniappStatusSaga() {
    yield takeLatest(PAYTM_MINIAPP_STATUS_CHECK, fetchPaytmMiniappStatus);
}
export function* phonepeSwitchPayment(request) {
    try {
        const { payload } = request;
        const { tenantId, data, customerId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paymentForPhonepeSwitchApp, null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.reservationId) {
            yield put(initiatePhonepeSwitchTransactionSuccess(response));
        }
        else {
            yield put(initiatePhonepeSwitchTransactionFailure());
        }
    }
    catch (error) {
        yield put(initiatePhonepeSwitchTransactionFailure());
    }
}
export function* payforPhonepeSwitchApp() {
    yield takeLatest(PHONEPE_SWITCH_INITIATE_TRANSACTION, phonepeSwitchPayment);
}
export const phonepeSwitchPaymentSelector = (state) => state.microAppPaymentReducer.phonepeMaxRepeatCallsCount;
export function* fetchPhonepeSwitchStatus(request) {
    try {
        const { payload } = request;
        const { tenantId, transactionId, customerId, maxCallCount } = payload;
        const maxRepeatCallsCount = yield select(phonepeSwitchPaymentSelector);
        const headers = {
            'x-tenant-id': tenantId,
            'x-user-id': customerId,
            'x-is-registered-user': true,
        };
        const { response, status } = yield call(invokeApi, networkConfig.phonepeSwitchAppStatus, { queryProps: { transactionId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.status && maxRepeatCallsCount < maxCallCount) {
            if (response?.status === MINI_APP_CONSTANTS.SUCCESS || response?.status === MINI_APP_CONSTANTS.FAILURE) {
                yield put(phonepeSwitchPaymentStatusSuccess(response));
            }
            else {
                yield delay(MINI_APP_CONSTANTS.STATUS_DELAY_TIME);
                yield put(checkPhonepeSwitchPaymentStatus(request?.payload, maxRepeatCallsCount + 1));
            }
        }
        else {
            yield put(phonepeSwitchPaymentStatusFailure(response));
        }
    }
    catch (error) {
        yield put(phonepeSwitchPaymentStatusFailure());
    }
}
export function* paymentStatusForPhonepeSwitch() {
    yield takeLatest(PHONEPE_SWITCH_STATUS_CHECK, fetchPhonepeSwitchStatus);
}
